import { takeLatest, select, call } from 'redux-saga/effects';
import { sendExperienceStatus } from 'api';

import * as actions from './actions';

function* sendHandl(action) {
  const state = yield select();
  const { payload: { callback } } = action;
  const { phone: { phone }, experience: { experience } } = state;

  try {
    yield call(sendExperienceStatus, +experience, phone);
    if (callback) {
      callback();
    }
  } catch (err) {
    console.log(err);
  }
}


export default function* () {
  yield takeLatest(
    actions.EXPERIENCE_SEND,
    sendHandl
  );
}



// WEBPACK FOOTER //
// ./src/pages/Experience/saga.js